function compare(value, condition) {
  let comparing = false;
  if (!condition.value) {
    return !comparing;
  }

  switch (condition.compare) {
    case '<=':
      comparing = value <= condition.value;
      break;
    case '>=':
      comparing = value >= condition.value;
      break;
    default:
      comparing = value === condition.value;
  }

  return comparing;
}

export default function filtering(data, hidden = [], expressions = {}) {
  if (!data || !data.length) {
    return [];
  }
  let visibleData = data;

  if (hidden.length) {
    visibleData = visibleData.map((item) => {
      const newItem = Object.assign({}, item);
      hidden.forEach(prop => delete newItem[prop]);
      return newItem;
    });
  }

  return visibleData.filter((item) => {
    let result = true;

    Object.keys(expressions).forEach((key) => {
      if (!result || !expressions[key].value) {
        return;
      }
      result = result && compare(item[key], expressions[key]);
    });

    return result;
  });
}
